export default "__VITE_ASSET__145b2364__"